import React from 'react';
import { Switch, Route } from 'react-router';
import CeeDetail from "./ceeDetail";
import CeeResultsAll from "./ceeResultsAll";
import CeeCause from "./ceeCause";
import AmlCompany from '../aml/amlCompany';
import AmlPath from '../aml/amlPath';
import AmlPerson from "../aml/amlPerson";

import '../aml/aml.scss';

class CeeResultsComponent extends React.Component {
    render() {

        return (

            <React.Fragment>
                <div className="report-container" style={{ fontSize: "0.875em"}}>
                <Switch>
                    <Route exact path={`${this.props.path}`} render={(props) => <CeeResultsAll {...props} registry={this.props.registry}/>} />
                    <Route exact path={`${this.props.path}/:id`} render={(props) => <CeeDetail {...props} />} />
                    <Route exact path={`${this.props.path}/company/:id`} component={AmlCompany} />
                    <Route exact path={`${this.props.path}/path/:id`} component={AmlPath} />
                    <Route exact path={`${this.props.path}/company/report/:id`} render={(props) => <AmlCompany {...props} asReport={true} />} />
                    <Route exact path={`${this.props.path}/person/:id`} component={AmlPerson} />
                    <Route exact path={`${this.props.path}/cause/:id`} component={CeeCause} />
                </Switch>
                </div>
            </React.Fragment>

        );
    }
}


export default CeeResultsComponent;
